import React from 'react'
import { observer } from 'mobx-react'
import PaginationOption from './PaginationOption'
import PaginationArrow from './PaginationArrow'

const Pagination = observer(({ model }) => {
  if (!model.totalPages || model.totalPages <= 1) {
    return null
  } else {
    const paginationOptions = []
    for (let i = 1; i <= model.totalPages; i++) {
      paginationOptions.push(i)
    }

    return (
        <div className='w-100'>
        <div className="events__page_options d-flex">
            <PaginationArrow arrow={{ side: ' left', active: model.currentPage === 1 ? ' nonactive' : ' active' }} model={model} ></PaginationArrow>

            {model.currentPage == 1 &&
              <React.Fragment>
                <PaginationOption option={{
                  id: 1,
                  content: 1,
                  checked: 'checked'
                }}
                model={model}
                /> {/* First page */}

                <PaginationOption option={{
                  id: 2,
                  content: 2,
                  checked: ''
                }}
                model={model}
                /> {/* Second page */}
              </React.Fragment>
            }

            {model.currentPage > 2 &&
              <PaginationOption option={{
                id: 1,
                content: 1,
                checked: ''
              }}
              model={model}
              /> /* First page */
            }

            {model.currentPage > 3 &&
              <div className='events__pages_option'>...</div>}

            {model.currentPage > 1 && model.currentPage < model.totalPages &&
              <React.Fragment>
                <PaginationOption option={{
                  id: model.currentPage - 1,
                  content: model.currentPage - 1,
                  checked: ''
                }}
                model={model}
                /> {/* ELement before current page */}

                <PaginationOption option={{
                  id: model.currentPage,
                  content: model.currentPage,
                  checked: 'checked'
                }}
                model={model}
                /> {/* ELement at current page */}

                <PaginationOption option={{
                  id: model.currentPage + 1,
                  content: model.currentPage + 1,
                  checked: ''
                }}
                model={model}
                /> {/* ELement after current page */}
              </React.Fragment>
            }

            {model.totalPages > 3 && model.currentPage < model.totalPages - 2 &&
              <div className='events__pages_option'>...</div>
            }

            {model.currentPage < model.totalPages - 1 &&
                <PaginationOption option={{
                  id: model.totalPages,
                  content: model.totalPages,
                  checked: ''
                }}
                model={model}
                /> /* Last page */
            }

            {model.currentPage == model.totalPages &&
              <React.Fragment>
                <PaginationOption option={{
                  id: model.currentPage - 1,
                  content: model.currentPage - 1,
                  checked: ''
                }}
                model={model}
                /> {/* Page before last */}

                <PaginationOption option={{
                  id: model.currentPage,
                  content: model.currentPage,
                  checked: 'checked'
                }}
                model={model}
                /> {/* Last page */}
              </React.Fragment>
            }

            <PaginationArrow arrow={{ side: ' right', active: model.currentPage === model.totalPages ? ' nonactive' : ' active' }} model={model}></PaginationArrow>
        </div>
        </div>
    )
  }
})

export default Pagination
